import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/bank-accounts/profile/loading';

export const Route = createFileRoute('/_private/settings/bank-accounts/$id')({
  pendingComponent: Loading,
});
